import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import dayjs, { Dayjs } from 'dayjs';
import { FkMdvModule } from 'src/app/core/ui/fk-mdv/fk-mdv.module';
import { PlannerLinkPlanner } from '../../planner-link.model';
import { LearnPlannerComponent } from '../learn-planner/learn-planner.component';

@Component({
  selector: 'app-learn-planner-day',
  standalone: true,
  imports: [DatePipe, FkMdvModule, RouterLink],
  templateUrl: './learn-planner-day.component.html',
  styleUrls: ['./learn-planner-day.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearnPlannerDayComponent {
  planner = input.required<PlannerLinkPlanner>();
  day = input.required<Dayjs>();
  isBottomLeft = input.required<boolean>();

  private plannerComponent = inject(LearnPlannerComponent);

  plan = computed(() => {
    const date = dayjs(this.day()).format('YYYY-MM-DD');
    return this.plannerComponent.getPlan(date);
  });

  get isToday() {
    return dayjs(this.day()).format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');
  }

  get isDayOff() {
    return false;
  }

}
